export async function readVisura(file) {
  if (!/\.pdf$/i.test(file.name) && file.type !== "application/pdf") return { data: {}, fields_found: 0 };
  const pdfjs = await import("pdfjs-dist/legacy/build/pdf.mjs");
  pdfjs.GlobalWorkerOptions.workerSrc = new URL("pdfjs-dist/legacy/build/pdf.worker.min.mjs", import.meta.url).toString();
  const task = pdfjs.getDocument({ data: await file.arrayBuffer(), isEvalSupported: false, useSystemFonts: true });
  let text = "";
  try {
    const pdf = await task.promise;
    for (let page = 1; page <= Math.min(pdf.numPages, 8); page++) {
      const content = await (await pdf.getPage(page)).getTextContent();
      let y;
      for (const item of content.items) {
        if (!item.str) continue;
        if (y !== undefined && Math.abs(item.transform[5] - y) > 2) text += "\n";
        text += `${item.str}${item.hasEOL ? "\n" : " "}`;
        y = item.transform[5];
      }
      text += "\n";
    }
  } finally { await task.destroy(); }
  const field = (pattern) => text.match(pattern)?.[1]?.trim() || undefined;
  const data = {
    ragione_sociale: field(/(?:denominazione|ragione\s+sociale)\s*:?\s*\n?\s*([^\n]{3,180})/i),
    partita_iva: field(/(?:partita\s*iva|p\.?\s*iva)\s*:?\s*(?:IT)?\s*(\d(?:[ .-]*\d){10})(?!\d)/i)?.replace(/\D/g, ""),
    sede_indirizzo: field(/(?:indirizzo\s+sede\s+legale|sede\s+legale|indirizzo)\s*:?\s*\n?\s*([^\n]{4,200})/i),
    pec: field(/(?:indirizzo\s+pec|pec|domicilio\s+digitale)\s*:?\s*\n?\s*([^\s@]+@[^\s@]+\.[^\s]+)/i),
  };
  return { data, fields_found: Object.values(data).filter(Boolean).length };
}
